function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*function Pager(){
 this.x = 1;
 this.n = 2;
 this.s = [];
 this.f = [];
 }*/

import { ArrayUtil } from "noood/util/array/ArrayUtil";
export var PagerMatchModeConstant = {
  EXACT: '==',
  WILDCARD_LEFT: 'x-',
  WILDCARD_RIGHT: '-x',
  WILDCARD_BOTH: 'xx',
  NOT_EMPTY: '!o',
  EMPTY: 'oo',
  IN: '[]',
  GREATER_THAN: '>x',
  LESS_THAN: '<x',
  BETWEEN: '()'
};

/**
 * @typedef {Object} FilterShape
 * @property {string} property
 * @property {PagerMatchModeConstant} match_mode one of the values from PagerMatchModeConstant
 * @property {string} value - the user input to match the database column's value
 */

/**
 * @typedef {Object} SorterShape
 * @property {string} property
 * @property {boolean} isAsc
 */

/**
 * @typedef Pager
 * @property {int} x
 */

/**
 * @class {Pager} Pager
 */
var Pager = /*#__PURE__*/function () {
  function Pager(init) {
    var _this = this,
      _init$x,
      _init$n,
      _init$s,
      _init$f;
    _classCallCheck(this, Pager);
    this.x = void 0;
    this.n = void 0;
    this.s = void 0;
    this.f = void 0;
    this.pg_str = void 0;
    this.from_form = function (obj) {
      var filters = Object.keys(obj);
      var new_pager = new Pager({
        n: 10
      });
      if ((filters === null || filters === void 0 ? void 0 : filters.length) > 0) {
        filters.map(function (filter, idx) {
          new_pager.add_or_update_filter(obj[filter]);
        });
      }
      return new_pager;
    };
    this.merge_from_form = function (formObj) {
      var _Object$keys;
      (_Object$keys = Object.keys(formObj)) === null || _Object$keys === void 0 || _Object$keys.map(function (F) {
        _this.add_or_update_filter(formObj[F]);
      });
      return _this;
    };
    this.x = (_init$x = init === null || init === void 0 ? void 0 : init.x) !== null && _init$x !== void 0 ? _init$x : 1; // current page
    this.n = (_init$n = init === null || init === void 0 ? void 0 : init.n) !== null && _init$n !== void 0 ? _init$n : 10; // result count per page
    this.s = (_init$s = init === null || init === void 0 ? void 0 : init.s) !== null && _init$s !== void 0 ? _init$s : []; // array of sorters [property,~property]
    this.f = (_init$f = init === null || init === void 0 ? void 0 : init.f) !== null && _init$f !== void 0 ? _init$f : []; // array of {FilterShape}
    // this.random = Math.random().toString(36);
  }
  return _createClass(Pager, [{
    key: "default",
    value: function _default() {
      return this.stringify();
    }
  }, {
    key: "update_next",
    value: function update_next() {
      var s = this.fix_defaults(this.pg_str);
      this.parse_to_self(s);
      this.x = parseInt(String(this.x)) + 1;
      return this.stringify();
    }
  }, {
    key: "parse_to_self",
    value: function parse_to_self(rawString) {
      var decoded_ = decodeURIComponent(this.pg_str);
      var pg = new Pager();
      pg.f = [];
      pg.s = [];
      decoded_.split("$").forEach(function (obj, idx) {
        if (obj[0] === 'f') {
          var filters = obj.substring(2, obj.length);
          var filter_property = filters.split("=")[0];
          var thisFilter = {
            property: filter_property,
            match_mode: filters.substring(filters.indexOf("=") + 1, 2),
            value: filters.substring(filters.indexOf("=") + 3, filters.length)
          };
          pg.f.push(thisFilter);
        } else if (obj[0] === 'x') {
          // offset
          pg.x = parseInt(obj.split(":")[1]);
        } else if (obj[0] === 'n') {
          pg.n = parseInt(obj.split(":")[1]);
        }
      });
      if (pg.x === void 0) {
        pg.x = 1;
      }
      if (pg.n === void 0) {
        pg.n = 1;
      }
      this.x = pg.x;
      this.n = pg.n;
      this.f = pg.f;
      this.s = pg.s;
    }
  }, {
    key: "parse",
    value: function parse(pg_str) {
      var pg = decodeURIComponent(pg_str);
      var filters = pg.split("$");
      for (var i = 0; i < filters.length; i++) {
        // filters
        if (filters[i][0] === 'f') {
          var filter_collection = filters[i].substring(2, filters[i].length);
          var filter_obj = null;
          try {
            JSON.parse(filter_collection);
          } catch (e) {}
          this.f = filter_obj;
          // let filter_k_v = filter_collection.split(",");
          // if (filter_k_v.length > 0) {
          // 	for (let j = 0; j < filter_k_v.length; j++) {
          // 		let this_filter = filter_k_v[j];
          // 		let filter_property = this_filter.split("=")[0];
          // 		let filter_match = this_filter.substring(this_filter.indexOf("=") + 1, this_filter.indexOf("=") + 3);
          // 		let filter_value = this_filter.substring(this_filter.indexOf("=") + 3);
          // 		this.f[filter_property] = filter_value;
          // 	}
          // }
        } else if (filters[i][0] === 'x') {
          var this_x = filters[i].split(":")[1];
          this.x = parseInt(this_x);
        }
      }
    }

    /**
     * @returns {string} a URL-encoded representation of this Pager
     */
  }, {
    key: "stringify",
    value: function stringify() {
      var parts_ = [];
      parts_.push('x:' + this.x);
      parts_.push('n:' + this.n);
      parts_.push('f:' + this.format_filters());
      parts_.push('s:' + this.format_sorters());
      var parts_str = parts_.join("$");
      return encodeURIComponent(parts_str);
    }
  }, {
    key: "fix_defaults",
    value: function fix_defaults(pg_str) {
      var decoded_pg = decodeURIComponent(pg_str);
      var pg = new Pager();
      var this_pager = new Pager();
      pg.f = [];
      pg.s = [];
      decoded_pg.split("$").forEach(function (obj, idx) {
        if (obj[0] === 'f') {
          var filters = obj.substring(2, obj.length);
          var filter_property = filters.split("=")[0];
          pg.f.push({
            match_mode: filters.substring(filters.indexOf("=") + 1, 2),
            value: filters.substring(filters.indexOf("=") + 3, filters.length),
            property: filter_property
          });
        } else if (obj[0] === 'x') {
          // offset
          pg.x = parseInt(obj.split(":")[1]);
        } else if (obj[0] === 'n') {
          pg.n = parseInt(obj.split(":")[1]);
        }
      });
      if (pg.x === void 0) {
        pg.x = 1;
      }
      if (pg.n === void 0) {
        pg.n = new Pager().n;
      }
      this_pager.x = pg.x;
      this_pager.n = pg.n;
      this_pager.f = pg.f;
      this_pager.s = pg.s;
      return this_pager.stringify();
    }
  }, {
    key: "format_filters",
    value: function format_filters() {
      var filters = [];
      if (this.f) {
        this.f.forEach(function (o, i) {
          filters.push(o.property + '=' + o.match_mode + o.value);
        });
      }
      return filters.join(",");
    }
  }, {
    key: "format_sorters",
    value: function format_sorters() {
      return ArrayUtil.hasElts(this.s) ? this.s.map(function (sorter) {
        return "".concat(sorter.isAsc ? '' : '~').concat(sorter.property);
      }) : '';
    }

    /**
     * @param filter FilterShape
     * @returns {Pager}
     */
  }, {
    key: "add_or_update_filter",
    value: function add_or_update_filter(filter) {
      var _this$f;
      if (((_this$f = this.f) === null || _this$f === void 0 ? void 0 : _this$f.length) > 0) {
        var index_of_filter = this.f.findIndex(function (f) {
          return f.property === filter.property;
        });
        if (index_of_filter > -1) {
          this.f[index_of_filter] = filter;
        } else {
          this.f.push(filter);
        }
      } else {
        if (!this.f) {
          this.f = [];
        }
        this.f.push(filter);
      }
      return this;
    }

    /**
     * @param {SorterShape} sorter
     */
  }, {
    key: "addOrUpdateSorter",
    value: function addOrUpdateSorter(sorter) {
      var _this$s;
      if (((_this$s = this.s) === null || _this$s === void 0 ? void 0 : _this$s.length) > 0) {
        var indexOfSorter = this.s.findIndex(function (thisSorter) {
          return thisSorter.property === sorter.property;
        });
        if (indexOfSorter > -1) {
          this.s[indexOfSorter] = sorter;
        } else {
          this.s.push(sorter);
        }
      } else {
        if (!this.s) {
          this.s = [];
        }
        this.s.push(sorter);
      }
    }
  }, {
    key: "set",
    value: function set(obj) {
      this.x = obj.x;
      this.n = obj.n;
      this.s = obj.s;
      this.f = obj.f;
      return this;
    }
  }, {
    key: "next_page",
    value: function next_page() {
      this.x = Number(this.x) + 1;
    }
  }, {
    key: "prev_page",
    value: function prev_page() {
      var previous = Number(this.x) - 1;
      this.x = previous >= 1 ? previous : 1;
    }
  }]);
}();
export { Pager as default };